import { ModalHelperProps } from 'src/components/Modal/Modal.types';
import { loadablePage } from 'src/utils/loadable';

export default loadablePage<React.FC<ModalHelperProps>>(
  () => import('./PaymSuccessModal.component'),
);
